import { Link } from 'react-router-dom';
import './BlindsCategory.css';


// TODO: replace with actual Callistus product catalog + images once finalized
// Using Callistus images/data as placeholders for now — first row reordered to match
// the live callistusblinds.ae layout (Roman Blinds, then Roller Blinds)
const blinds = [
  { title: "Roller Blinds", desc: 'Square Fascia ', img: '/Assets/CategoryImages/Square.png', link: '/square-fascia' },
  { title: 'Roman Blinds', desc: 'Roman Blinds Tradition & Contemporary', img: '/Assets/CategoryImages/Roman.png', link: '/products/roman-blinds' },

  { title: 'Special Solution', desc: 'Solution For Challenging Architectural Design Window', img: '/Assets/CategoryImages/Slant.png', link: '/products/skylight-blinds' },
  { title: 'Skylight Blinds', desc: 'Innovative Window Furnishing', img: '/Assets/CategoryImages/skylight.png', link: '/products/grayson-blinds' },
  { title: 'Grayson Blind', desc: 'Grayson Blinds Simple,Classic and Elegant', img: '/Assets/CategoryImages/Grayson.png', link: '/products/luzon-blinds' },
  { title: 'Curtain Track', desc: 'Manual & Motorized', img: '/Assets/CategoryImages/Tracks.png', link: '/products/sierra-blinds' },

  { title: 'Colby Blinds', desc: 'Beauty and Energy Efficiency', img: '/Assets/CategoryImages/Colby.png', link: '/products/colby-blinds' },
  { title: 'Automation', desc: 'Improves Function,Comfort,Pleasure and Adds Value in Life', img: '/Assets/CategoryImages/c8.webp', link: '/printed-blinds' },

  { title: 'Luzon Blinds', desc: 'Enjoy Privacy and An Open View At THe Same Time', img: '/Assets/CategoryImages/Luzon.jpg', link: '/products/wooden-venetian-blinds' },
  { title: "Roller Blinds", desc: 'At Project Site', img: '/Assets/CategoryImages/Roller.webp', link: '/products/roller-blinds' },
];


const BlindsCategory = () => {
  const paired = [];
  for (let i = 0; i < blinds.length; i += 2) {
    paired.push(blinds.slice(i, i + 2));
  }

  return (
    <section className="CategorySection">
      <div className="blinds-section">
        <h2 className="blinds-title">Customized Window Blinds</h2>
        <p className="blinds-subtitle">
          Explore how Callistus Blinds window treatments transform the light into your home or offices,
          elevating everyday living and add beauty to the mood of your unique space.
        </p>

        <div className="blinds-wrapper">
          {paired.map((pair, index) => {
            // The Grayson Blind + Curtain Track pair needs its own layout: the
            // Curtain Track image is a wide multi-panel collage (5 track types +
            // 2 close-ups), so it gets more width and must not be cropped.
            const isTrackRow = pair.some((item) => item.title === 'Curtain Track');
            const rowClass = isTrackRow ? 'row-track' : `row-${(index % 5) + 1}`;
            return (
              <div className={`blinds-row ${rowClass}`} key={index}>
                {pair.map((item, subIndex) => {
                  const isExternal = item.link.startsWith('http');
                  const CardTag = isExternal ? 'a' : Link;
                  const cardProps = isExternal
                    ? { href: item.link, target: '_blank', rel: 'noopener noreferrer' }
                    : { to: item.link };
                  const isTrackImage = item.title === 'Curtain Track';
                  const isNoCropImage = isTrackImage || item.desc === 'At Project Site' || item.title === 'Grayson Blind';

                  return (
                    <CardTag
                      className={`blinds-card card-${subIndex + 1}${isNoCropImage ? ' card-notrim' : ''}`}
                      key={subIndex}
                      {...cardProps}
                    >
                      <div className="blinds-image-wrapper">
                        <img src={item.img} alt={item.title} className="blinds-image" />
                      </div>
                      <div className="blinds-text">
                        <div className="blinds-label">{item.title}</div>
                        <div className="blinds-subtext">{item.desc}</div>
                      </div>
                    </CardTag>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
      <div style={{ marginTop: "10px" }} className="footer-column">
        <button className='seeProdBtn' onClick={() => (window.location.href = "/products")}>
          See All Products
        </button>
      </div>


    </section>
  );
};

export default BlindsCategory;